import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Account } from '../models/account';
import { environment } from '../../environments/environment';
import { HttpResponseInterface } from '../interfaces/iHttpResponse';
import { Router } from '@angular/router';
import { AccountService } from './account.service';
import { TimeZoneService } from './timezone.service';
import { from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})


export class AuthenticationService {
  public loggedIn = new BehaviorSubject<boolean>(false);
  public accountChanged = new EventEmitter<any>();

  private urlBrevo = 'https://api.brevo.com/v3/contacts';
  private apiKey = environment.brevoKEY;

  constructor(private http: HttpClient, private router:Router, private accountService:AccountService, private timezoneService: TimeZoneService) {
    if (this.getToken()) {
      this.loggedIn.next(true);
    }
  }

  public login(email: string, password: string): Observable<any> {
    return this.http.post<HttpResponseInterface>(`${environment.apiEndpoint}/api/login`, {email: email, password: password}).pipe(
      map(res => {
        return res;
      })
    );
  }

  public register(registration): Observable<any> {
    const newAccount = new Account(registration);
    return this.http.post<HttpResponseInterface>(`${environment.apiEndpoint}/api/register`, newAccount).pipe(
      map((res) => {
        // this.storeLogin(res);
        // this.router.navigate(['/']);
        return res;
      })
    );
  }

  public registerBrevoV1(registration): void
  {
    const newAccount = new Account(registration);

    const lambdaBrevoUrl = 'https://igsranf0fb.execute-api.eu-west-1.amazonaws.com/v1-centralcpd-brevo';

    const headers = {
      accept: 'application/json',
      'content-type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
      "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With"
    };

    const body = {
      email: newAccount.email,
      name: newAccount.first_name,
      lastname: newAccount.last_name,
      opt_in: newAccount.opt,
      job_role: newAccount.type
    };

    const result = from(
      fetch(
        lambdaBrevoUrl,
        {
          body: JSON.stringify(body),
          headers: headers,
          method: 'POST',
          mode: 'no-cors'
        }
      )
    );
  }

  public logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('account');
    localStorage.removeItem('practiceName');
    localStorage.removeItem('practiceImage');
    localStorage.removeItem('limitedPractice');
    localStorage.removeItem('practiceDisabled');
    localStorage.removeItem('notifications');
    this.loggedIn.next(false);
    this.router.navigate(['/']);
  }

  public clear(){
    localStorage.removeItem('token');
    localStorage.removeItem('account');
    localStorage.removeItem('practiceName');
    localStorage.removeItem('practiceImage');
    localStorage.removeItem('limitedPractice');
    localStorage.removeItem('practiceDisabled');
    localStorage.removeItem('notifications');
    this.loggedIn.next(false);
  }

  public verifyEmail(emailHash:string):Observable<any>{
    return this.http.post(environment.apiEndpoint+'/api/verify-email', {emailHash:emailHash}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public resendVerification(email:string):Observable<any>{
    return this.http.post(environment.apiEndpoint+'/api/resend-verification', {email:email}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public testForPracticeRegistered(emailHash:string):Observable<any>{
    return this.http.post(environment.apiEndpoint+'/api/testForPracticeRegistered', {emailHash:emailHash}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public completePracticeRegistered(emailHash:string, password:string):Observable<any>{
    return this.http.post(environment.apiEndpoint+'/api/completePracticeRegistered', {emailHash:emailHash, password:password}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  storeLogin(data) {
    const currentCountry = localStorage.getItem('selectedCountry');
    localStorage.setItem('token', data.token);
    localStorage.setItem('account',JSON.stringify(data.user));
    const profileCountry = data.user && data.user.country_preference ? data.user.country_preference : null;
    if (profileCountry) {
      this.timezoneService.setCountryLocalOnly(profileCountry);
    }
    if(data.practice) {
      localStorage.setItem('practiceName', data.practice.name);
      if(data.user.subscriptions[0] && data.user.subscriptions[0].status=='active') {
        localStorage.setItem('limitedPractice', '0');
      } else {
        localStorage.setItem('limitedPractice', data.practice.limited);
      }
      localStorage.setItem('practiceDisabled', data.practice.disabled);
      if (data.practice.media && data.practice.media.url) {
        localStorage.setItem('practiceImage', environment.apiEndpoint+'/storage/practices/'+data.practice.media.url);
      }
    }
    this.loggedIn.next(true);
    if (profileCountry && profileCountry !== currentCountry) {
      window.location.href = '/';
    }
  }

  public getToken() {
    return localStorage.getItem('token');
  }

  public getAccount() {
    return new Account(JSON.parse(localStorage.getItem('account')));
  }


}
